<template>
  <div>
    <div class="tabs-content">
      <el-tabs v-model="ygTypeActive" @tab-click="changeYgTypeActive">
        <el-tab-pane label="出库" name="A"></el-tab-pane>
        <el-tab-pane label="入库" name="B"></el-tab-pane>
      </el-tabs>
    </div>
    <custom-actions title="已预约" sub-title="走预约流程">
      <el-tabs v-model="activeName" @tab-click="changePlanType">
        <el-tab-pane :label="item[1]" :name="item[0]" v-for="(item, index) of Array.from(planTypeMap)"
                     :key="index"></el-tab-pane>
      </el-tabs>
      <!-- 只有出库的时候才显示统计数据 -->
      <el-row class="mb15" v-if="ygTypeActive === 'A'">
        <el-col :span="4">最大出货量：{{ info.planNum || '0' }}</el-col>
        <el-col :span="4">
          <div style="display: flex;align-items: center;">
            <span>
              已约出货量：
            </span>
            <el-button :disabled="!(parseFloat(info.yyPlanNum) > 0)" style="padding: 0;text-decoration: underline;"
                       class="ml10" type="text" @click="loadGgList(searchForm1.plannedDate)">{{ info.yyPlanNum || '0'
              }}</el-button>
          </div>
        </el-col>
        <el-col :span="4">早餐数量：{{ info.yyMealNum2 || '0' }}</el-col>
        <el-col :span="4">午餐数量：{{ info.yyMealNum3 || '0' }}</el-col>
        <el-col :span="4">晚餐数量：{{ info.yyMealNum4 || '0' }}</el-col>
      </el-row>
      <el-form :model="searchForm1" ref="searchForm1" inline class="global-form-label-width account-form"
               label-width="100px">
        <el-form-item prop="plannedDate">
          <el-date-picker v-model="searchForm1.plannedDate" placeholder="请选择计划入场日期" type="date" clearable
                          format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch('1')">查询</el-button>
          <el-button @click="onReset('searchForm1')">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table key="123" v-if="activeName === '1'" size="mini" stripe border v-loading="loading"
                :cell-style="tableCellStyle" :data="tableData1">
        <el-table-column min-width="130" align="center" fixed="left" label="时间段" prop="timeslotVal"></el-table-column>
        <el-table-column label="小车" align="center">
          <el-table-column prop="xcKh" min-width="140" show-overflow-tooltip align="center" label="客户"></el-table-column>
          <el-table-column prop="xcOrderNumber" min-width="140" show-overflow-tooltip align="center" label="提货单号"></el-table-column>
          <el-table-column min-width="140" align="center" label="车牌号">
            <template v-slot="{ row }">
              {{ row.xcNumber || '--' }}
              <span v-if="isMealFormatMap.get(row.xcMe)">
                ({{ isMealFormatMap.get(row.xcMe) }})
              </span>
            </template>
          </el-table-column>
          <el-table-column min-width="110" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <div v-if="row.xcSl" style="display: flex;justify-content: center;align-items: center;">
                <el-button type="text" @click="loadGgList(row.xcId)">{{ row.xcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="130" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.xcZt) || '--' }}</span>
              <span v-if="row.xcRe === '6'">(已完成)</span>
            </template>
          </el-table-column>
          <el-table-column width="160" align="center" label="操作">
            <template v-slot="{ row }">
              <template v-if="row.xcId">
                <el-button v-if="hasCancel && row.xcRe === '2' && row.xcNumber" type="text"
                           @click="cancelArrival(row.xcId)">取消</el-button>
                <el-button type="text" v-if="hasArrival && row.xcRe === '2'"
                           @click="confirmArrival(row.xcId)">确认签到</el-button>
                <el-button v-if="hasCancelSign && row.xcRe === '3' && row.xcNumber" type="text"
                           @click="cancelArrival(row.xcId)">取消签到</el-button>
                <el-button v-if="hasBeginZh && row.xcRe === '3' && row.xcNumber" type="text"
                           @click="beginArrival(row.xcId)">开始{{cargoName}}</el-button>
                <el-button v-if="hasEndZh && row.xcRe === '4' && row.xcNumber" type="text"
                           @click="endArrival(row.xcId)">{{cargoName}}完成</el-button>
                <el-button v-if="hasComplete && row.xcRe === '5'" type="text"
                           @click="loadGgList(row.xcId, '2')">确认完成</el-button>
                <plan-document-actions :plan-id="row.xcId" :status="row.xcRe" :yg-type="ygTypeActive" />
                <el-button v-if="hasFreight && row.xcId" class="ml10" type="text" @click="openFreightDialog(row.xcId, row.xcSl)">运费</el-button>
                <el-button v-if="row.xcNumber" type="text"
                           @click=" $router.push('/entryplanall/detail?planId=' + row.xcId)">详情</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="大车" align="center">
          <el-table-column prop="dcKh" min-width="140" show-overflow-tooltip align="center" label="客户"></el-table-column>
          <el-table-column prop="dcOrderNumber" min-width="140" show-overflow-tooltip align="center" label="提货单号"></el-table-column>
          <el-table-column min-width="140" align="center" label="车牌号">
            <template v-slot="{ row }">
              {{ row.dcNumber || '--' }}
              <span v-if="isMealFormatMap.get(row.dcMe)">
                ({{ isMealFormatMap.get(row.dcMe) }})
              </span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <div v-if="row.dcSl" style="display: flex;justify-content: center;align-items: center;">
                <el-button type="text" @click="loadGgList(row.dcId)">{{ row.dcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="140" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.dcZt) || '--' }}</span>
              <span v-if="row.dcRe === '6'">(已完成)</span>
            </template>
          </el-table-column>
          <el-table-column width="160" align="center" label="操作">
            <template v-slot="{ row }">
              <template v-if="row.dcId">
                <el-button v-if="hasCancel && row.dcRe === '2' && row.dcNumber" type="text"
                           @click="cancelArrival(row.dcId)">取消</el-button>
                <el-button type="text" v-if="hasArrival && row.dcRe === '2'"
                           @click="confirmArrival(row.dcId)">确认签到</el-button>
                <el-button v-if="hasCancelSign && row.dcRe === '3' && row.dcNumber" type="text"
                           @click="cancelArrival(row.dcId)">取消签到</el-button>
                <el-button v-if="hasBeginZh && row.dcRe === '3' && row.dcNumber" type="text"
                           @click="beginArrival(row.dcId)">开始{{cargoName}}</el-button>
                <el-button v-if="hasEndZh && row.dcRe === '4' && row.dcNumber" type="text"
                           @click="endArrival(row.dcId)">{{cargoName}}完成</el-button>
                <el-button v-if="hasComplete && row.dcRe === '5'" type="text"
                           @click="loadGgList(row.dcId, '2')">确认完成</el-button>
                <plan-document-actions :plan-id="row.dcId" :status="row.dcRe" :yg-type="ygTypeActive" />
                <el-button v-if="hasFreight && row.dcId" class="ml10" type="text" @click="openFreightDialog(row.dcId, row.dcSl)">运费</el-button>
                <el-button v-if="row.dcNumber" type="text"
                           @click=" $router.push('/entryplanall/detail?planId=' + row.dcId)">详情</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-table key="456" v-if="activeName === '2'" size="mini" stripe border v-loading="loading"
                :cell-style="tableCellStyle" :data="tableData1">
        <el-table-column min-width="130" align="center" fixed="left" label="时间段" prop="timeslotVal"></el-table-column>
        <el-table-column label="罐车" align="center">
          <el-table-column prop="gcKh" min-width="140" show-overflow-tooltip align="center" label="客户"></el-table-column>
          <el-table-column prop="gcOrderNumber" min-width="140" show-overflow-tooltip align="center" label="提货单号"></el-table-column>
          <el-table-column min-width="140" align="center" label="车牌号">
            <template v-slot="{ row }">
              {{ row.gcNumber || '--' }}
              <span v-if="isMealFormatMap.get(row.gcMe)">
                ({{ isMealFormatMap.get(row.gcMe) }})
              </span>
            </template>
          </el-table-column>
          <el-table-column min-width="110" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <div v-if="row.gcSl" style="display: flex;justify-content: center;align-items: center;">
                <el-button type="text" @click="loadGgList(row.gcId)">{{ row.gcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="130" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.gcZt) || '--' }}</span>
              <span v-if="row.gcRe === '6'">(已完成)</span>
            </template>
          </el-table-column>
          <el-table-column width="160" align="center" label="操作">
            <template v-slot="{ row }">
              <template v-if="row.gcId">
                <el-button v-if="hasCancel && row.gcRe === '2' && row.gcNumber" type="text"
                           @click="cancelArrival(row.gcId)">取消</el-button>
                <el-button type="text" v-if="hasArrival && row.gcRe === '2'"
                           @click="confirmArrival(row.gcId)">确认签到</el-button>
                <el-button v-if="hasCancelSign && row.gcRe === '3' && row.gcNumber" type="text"
                           @click="cancelArrival(row.gcId)">取消签到</el-button>
                <el-button v-if="hasBeginZh && row.gcRe === '3' && row.gcNumber" type="text"
                           @click="beginArrival(row.gcId)">开始{{cargoName}}</el-button>
                <el-button v-if="hasEndZh && row.gcRe === '4' && row.gcNumber" type="text"
                           @click="endArrival(row.gcId)">{{cargoName}}完成</el-button>
                <el-button v-if="hasComplete && row.gcRe === '5'" type="text"
                           @click="loadGgList(row.gcId, '2')">确认完成</el-button>
                <plan-document-actions :plan-id="row.gcId" :status="row.gcRe" :yg-type="ygTypeActive" />
                <el-button type="text" class="ml10" @click="openFreightDialog(row.gcId, row.gcSl)">运费</el-button>
                <el-button type="text"
                           @click=" $router.push('/entryplanall/detail?planId=' + row.gcId)">详情</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </custom-actions>

    <custom-actions title="未预约" sub-title="走非预约流程" class="mt10">
      <template #header>
        <el-button type="primary" v-if="hasAdd"
                   @click="$router.push('/entryplanall/add?ygType=' + ygTypeActive)">新增</el-button>
      </template>
      <el-tabs v-model="activeName" @tab-click="changePlanType">
        <el-tab-pane :label="item[1]" :name="item[0]" v-for="(item, index) of Array.from(planTypeMap)"
                     :key="index"></el-tab-pane>
      </el-tabs>
      <el-form :model="searchForm2" ref="searchForm2" inline class="global-form-label-width account-form"
               label-width="100px">
        <!-- 新增客户名称搜索 -->
        <el-form-item prop="userName">
          <el-input v-model="searchForm2.userName" placeholder="请输入客户名称" />
        </el-form-item>
        <el-form-item prop="plateNumber">
          <el-input v-model="searchForm2.plateNumber" placeholder="请输入车牌号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch('2')">查询</el-button>
          <el-button @click="onReset('searchForm2')">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table class="mt20" size="mini" stripe border v-loading="loading" :data="tableData2">
        <el-table-column min-width="120" label="关联工单号" prop="orderNumber"></el-table-column>
        <el-table-column min-width="120" label="关联客户" prop="userName"></el-table-column>
        <el-table-column min-width="120" label="车牌号" prop="plateNumber"></el-table-column>
        <el-table-column min-width="120" label="挂车号" prop="vehicleGph"></el-table-column>
        <el-table-column min-width="120" label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column min-width="120" label="司机手机号" prop="driverPhone"></el-table-column>
        <el-table-column min-width="160" label="司机身份证" prop="driverId"></el-table-column>
        <el-table-column min-width="120" label="车辆类型" prop="vehicleType">
          <template v-slot="{ row }">
            {{ vehicleTypeMap.get(row.vehicleType) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="计划数量" prop="plannedNum">
          <template v-slot="{ row }">
            <div style="display: flex;;align-items: center;">
              <el-button type="text" @click="loadGgList(row.planId)">{{ row.plannedNum || '--' }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="可预约时间段" prop="">
          <template v-slot="{ row }">
            {{ row.vehicleDateStart }} 至 {{ row.vehicleDateEnd || '--' }}
          </template>
        </el-table-column>

        <el-table-column width="220" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/entryplanall/detail?planId=' + row.planId)">详情</el-button>
            <el-button type="text" v-if="hasEdit"
                       @click="$router.push('/entryplanall/edit?planId=' + row.planId)">编辑</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.planId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData2">
      </el-pagination>
    </custom-actions>

    <el-dialog title="入场规格清单" :visible.sync="guigeVisible" width="800px">
      <el-table size="mini" stripe border v-loading="loading" :data="planGgList">
        <el-table-column min-width="180" label="规格名称" prop="specName"></el-table-column>
        <el-table-column min-width="100" label="规格单位" prop="unit"></el-table-column>
        <el-table-column min-width="100" label="计划数量" prop="planQuantity"></el-table-column>
        <el-table-column min-width="100" :label="ygTypeActive === 'A'?'实提数量':'发货数量'" prop="pickupQuantity"></el-table-column>
        <el-table-column min-width="100" v-if="ygTypeActive === 'B'" label="到货数量" prop="arrivalQuantity"></el-table-column>
        <el-table-column v-if="gGviewType === '2'" min-width="100" label="操作">
          <template v-slot="{ row }">
            <el-button type="text" @click="showNumber(row)">填写数量</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" v-if="gGviewType === '2'" class="dialog-footer">
        <el-button @click="guigeVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmComplete">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="填写数量" class="global-dialog" :visible.sync="showNumberVisible" width="600px">
      <div class="dlg-content">
        <el-form class="global-form" style="padding:30px 40px 20px 20px" :model="formData2" :rules="rules2" ref="form2"
                 label-width="120px">
          <el-row>
            <el-col :span="124">
              <el-form-item prop="pickupQuantity" :label="ygTypeActive === 'A'?'实提数量':'发货数量'">
                <el-input v-model="formData2.pickupQuantity" placeholder="请输入发货数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col v-if="ygTypeActive === 'B'" :span="124">
              <el-form-item prop="arrivalQuantity" label="到货数量">
                <el-input v-model="formData2.arrivalQuantity" placeholder="请输入到货数量"></el-input>
              </el-form-item>
            </el-col>
            <template v-if="ygTypeActive === 'B'">
              <el-col :span="124">
                <el-form-item prop="vehicleStartAddress" label="实际入库">
                  <el-select v-model="formData2.vehicleStartAddress" filterable placeholder="请选择实际入库">
                    <el-option :value="item.warehouseId" :label="item.warehouseName"
                               v-for="(item, index) of vehicleStartAddressList" :key="index"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showNumberVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePickupQuantity">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="global-dialog" :append-to-body="true" :visible.sync="comfirmVisible" :title="`确认${cargoName}`" width="500">
      <el-form class="global-form" :model="formData3" :rules="rules3" ref="form3" style="padding: 30px 40px 20px 20px;">
        <el-form-item label="附件">
          <file-upload v-model="formData3.fileList" :multiple="true" :limit="10"></file-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="comfirmVisible = false">取消</el-button>
          <el-button type="primary" @click="submitComplete">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog class="global-dialog" :append-to-body="true" :visible.sync="arrivalVisible"
               :title="(arrivalType === 'begin' ? '开始' : '结束') + cargoName" width="500">
      <el-form class="global-form" :model="arrivalForm" :rules="arrivalRules" ref="arrivalForm"
               style="padding: 30px 40px 20px 20px;">
        <el-form-item label="附件">
          <file-upload v-model="arrivalForm.fileList" :multiple="true" :limit="10"></file-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="arrivalVisible = false">取消</el-button>
          <el-button type="primary" @click="submitArrival">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 运费弹框 -->
    <el-dialog title="运费添加" :visible.sync="freightVisible" width="600px">
      <el-form class="global-form" :model="freightForm" :rules="freightRules" ref="freightFormRef" label-width="130px">
        <el-form-item prop="transportCompany" label="运输公司">
          <el-input v-model="freightForm.transportCompany" placeholder="请输入运输公司"></el-input>
        </el-form-item>
        <el-form-item prop="freightType" label="运费类型">
          <el-select v-model="freightForm.freightType" placeholder="请选择运费类型" @change="calcTotalPrice">
            <el-option label="一口价" value="1"></el-option>
            <el-option label="单价" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="unitPrice" label="费用(元)">
          <el-input-number v-model="freightForm.unitPrice" :precision="2" @change="calcTotalPrice"></el-input-number>
        </el-form-item>
        <el-form-item prop="totalPrice" label="总价(元)">
          <el-input-number v-model="freightForm.totalPrice" disabled :precision="2"></el-input-number>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="freightVisible = false">取消</el-button>
          <el-button type="primary" @click="submitFreight">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import PlanDocumentActions from './PlanDocumentActions.vue'
import { vehicleType, reservationStatus, arrivalStatus, isMealFormat, planType } from '@/utils/dict'
import { validNumber3 } from '@/utils/validator'
import { deepClone } from '@/utils/utils'

export default {
  components: { PlanDocumentActions },
  name: 'EntryPlan',
  mixins: [keepAlive],
  data() {
    return {
      currentPickupId: '',
      ygTypeActive: 'A',
      activeName: '1',
      planTypeMap: planType,
      guigeVisible: false,
      gGviewType: '1',
      vehicleTypeMap: vehicleType,
      reservationStatusMap: reservationStatus,
      arrivalStatusMap: arrivalStatus,
      isMealFormatMap: isMealFormat,
      tableData1: [],
      planGgList: [],
      comfirmVisible: false,
      page: 1,
      total: 0,
      loading: false,
      rules3: {
        fileList: [
          { required: true, message: '请上传附件', trigger: 'change' }
        ]
      },
      rules2: {
        pickupQuantity: [
          { required: true, message: '请输入发货数量' },
          { pattern: validNumber3, message: '请输入数字可保留三位小数' }
        ],
        arrivalQuantity: [
          { pattern: validNumber3, message: '请输入数字可保留三位小数' }
        ]
      },
      searchForm2: {
        plateNumber: '', // 车牌号关键词
        userName: '', // 关联客户名称关键词
        reservationStatus: '1' // 未预约区域固定查询待预约记录
      },
      tableData2: [],
      // 已预约区域仅按计划入场日期筛选。
      searchForm1: {
        plannedDate: '' // 计划入场日期
      },
      formData3: {
        fileList: []
      },
      showNumberVisible: false,
      vehicleStartAddressList: [],
      formData2: {
        pickupQuantity: '',
        arrivalQuantity: '',
        vehicleStartAddress: '',
        planQuantity: '', // 这个计划数量是用来和实际数量做对比的，提交的时候需要删除
        specId: '',
        orderId: ''
      },
      info: {
        planNum: '0', // 计划产能
        yyPlanNum: '0', // 已约出货量
        yyMealNum: '0',
        yyMealNum2: '0', // 已约早餐量
        yyMealNum3: '0', // 已约午餐量
        yyMealNum4: '0' // 已约晚餐量
      },
      arrivalVisible: false,
      arrivalType: '',
      arrivalRules: {
        fileList: [
          { required: true, type: 'array', message: '请上传附件', trigger: 'change' }
        ]
      },
      arrivalForm: {
        planId: '',
        fileList: []
      },
      // 运费弹框
      freightVisible: false,
      freightSl: 0,
      freightForm: {
        planId: '',
        transportCompany: '',
        freightType: '',
        unitPrice: '',
        totalPrice: ''
      },
      freightRules: {
        transportCompany: [{ required: true, message: '请输入运输公司', trigger: 'blur' }],
        freightType: [{ required: true, message: '请选择运费类型', trigger: 'change' }],
        unitPrice: [{ required: true, message: '请输入费用', trigger: 'blur' }]
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasComplete() {
      return this.buttonList.includes('complete')
    },
    hasBeginZh() {
      return this.buttonList.includes('beginZh')
    },
    hasEndZh() {
      return this.buttonList.includes('endZh')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasArrival() { // 门卫签到
      return this.buttonList.includes('arrival')
    },
    hasCancel() {
      return this.buttonList.includes('cancel')
    },
    hasCancelSign() {
      return this.buttonList.includes('cancelSign')
    },
    hasFreight() {
      return this.buttonList.includes('freight')
    },
    cargoName() {
      return this.ygTypeActive === 'A' ? '装货' : '卸货'
    }
  },
  created() {
    this.searchForm1.plannedDate = this.$dayjs().format('YYYY-MM-DD')
    this.loadData1()
    this.loadData2()
    this.loadDict()
  },
  methods: {
    initData() {
      this.loadData1()
      this.loadData2()
    },
    changeYgTypeActive() {
      this.loadData1()
      this.loadData2()
    },
    changePlanType() {
      this.loadData1()
      this.loadData2()
    },
    checkExpired(timeslotVal) {
      const data = timeslotVal.match(/\((.*?)\)(\d{2}:\d{2})~(\d{2}:\d{2})/)
      let currentTime = this.$dayjs(this.searchForm2.plannedDate + ' ' + data[3])
      if (data[1] === '次日') {
        currentTime = currentTime.add(1, 'day')
      }
      return currentTime.isBefore(this.$dayjs())
    },
    showNumber(row) {
      console.log('当前数据', row)
      this.formData2.pickupQuantity = row.pickupQuantity || ''
      this.formData2.arrivalQuantity = row.arrivalQuantity || ''
      this.formData2.planQuantity = row.planQuantity || ''
      this.formData2.vehicleStartAddress = row.vehicleStartAddress || ''
      this.formData2.orderId = row.orderId
      this.formData2.specId = row.specId
      this.showNumberVisible = true
    },
    updatePickupQuantity() {
      this.$refs.form2.validate().then(() => {
        if (this.ygTypeActive === 'B' && Math.abs(this.formData2.pickupQuantity - this.formData2.arrivalQuantity) > 0.002) {
          this.$confirm('发货数量和到货数量差值超过0.002, 是否确认提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const formData2 = deepClone(this.formData2)
            delete formData2.planQuantity
            this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder2, {
              ...formData2,
              pickupId: this.currentPickupId
            }).then(res => {
              this.loadGgList(this.currentPickupId, '2')
              this.showNumberVisible = false
            })
          })
        } else if (this.ygTypeActive === 'A' && Math.abs(this.formData2.pickupQuantity - this.formData2.planQuantity) > 0.002) {
          this.$confirm('实提数量和计划数量差值超过0.002, 是否确认提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const formData2 = deepClone(this.formData2)
            delete formData2.planQuantity
            this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder2, {
              ...formData2,
              pickupId: this.currentPickupId
            }).then(res => {
              this.loadGgList(this.currentPickupId, '2')
              this.showNumberVisible = false
            })
          })
        } else {
          const formData2 = deepClone(this.formData2)
          delete formData2.planQuantity
          this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder2, {
            ...formData2,
            pickupId: this.currentPickupId
          }).then(res => {
            this.loadGgList(this.currentPickupId, '2')
            this.showNumberVisible = false
          })
        }
      })
    },
    loadGgList(planId, gGviewType = '1') {
      this.gGviewType = gGviewType
      this.currentPickupId = planId
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanGg, {
        planId
      }).then(res => {
        this.planGgList = res || []
        this.guigeVisible = true
      })
    },
    confirmComplete() {
      if (!this.planGgList.every(item => item.pickupQuantity)) {
        this.$message({
          message: '请检查规格清单，发货数量不能为空',
          type: 'warning'
        })
        return
      }
      this.formData3.fileList = []
      this.comfirmVisible = true
    },
    submitComplete() {
      this.$refs.form3.validate().then(() => {
        this.$axios.post(this.$apis.deliveryOrder.editCYWlVehiclePlanCc, {
          ...this.formData3,
          planId: this.currentPickupId
        }).then(res => {
          this.loadData1()
          this.loadData2()
          this.guigeVisible = false
          this.comfirmVisible = false
        })
      })
    },
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (row.xcNumber && row.xcZt === '1' && this.checkExpired(row.timeslotVal) && columnIndex >= 1 && columnIndex <= 5) {
        return {
          background: '#F56C6C',
          color: '#FFFFFF'
        }
      }
      if (row.dcNumber && row.dcZt === '1' && this.checkExpired(row.timeslotVal) && columnIndex >= 7 && columnIndex <= 11) {
        return {
          background: '#F56C6C',
          color: '#FFFFFF'
        }
      }
    },
    confirmArrival(planId) {
      this.$confirm('确认该车辆已入场, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.editMwWlVehiclePlan, {
          planId
        }).then(() => {
          this.loadData1()
          this.loadData2()
        })
      })
    },
    submitArrival() {
      this.$refs.arrivalForm.validate().then(() => {
        let url = this.$apis.clyy.editCYWlVehiclePlanZh
        if (this.arrivalType === 'end') {
          url = this.$apis.clyy.editMwWlVehiclePlanZhWc
        }
        this.$axios.post(url, this.arrivalForm).then(() => {
          this.arrivalVisible = false
          this.loadData1()
          this.loadData2()
        })
      })
    },
    beginArrival(planId) {
      this.arrivalForm.planId = planId
      this.arrivalForm.fileList = []
      this.arrivalType = 'begin'
      this.arrivalVisible = true
      this.$nextTick(() => {
        this.$refs.arrivalForm.clearValidate()
      })
    },
    endArrival(planId) {
      this.arrivalForm.planId = planId
      this.arrivalForm.fileList = []
      this.arrivalType = 'end'
      this.arrivalVisible = true
      this.$nextTick(() => {
        this.$refs.arrivalForm.clearValidate()
      })
    },
    cancelArrival(planId) {
      this.$confirm('确认取消该预约吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.editWlVehiclePlanQx, {
          planId
        }).then(() => {
          this.loadData2()
          this.loadData()
        })
      })
    },
    deleteRow(planId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.deleteDataWlVehiclePlan, {
          planId
        }).then(() => {
          this.loadData()
        })
      })
    },
    loadDict() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage, {}).then(res => {
        this.vehicleStartAddressList = res.list
      })
    },
    loadData2() {
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanByPage, {
        ...this.searchForm2,
        page: this.page,
        size: 10,
        planType: this.activeName,
        ygType: this.ygTypeActive
      }).then(res => {
        this.tableData2 = res.list
        this.total = res.total
      })
    },
    loadData1() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDayByList2, {
        ...this.searchForm1,
        planType: this.activeName,
        ygType: this.ygTypeActive
      }).then(res => {
        this.tableData1 = res || []
        this.loadCount()
      })
    },
    loadCount() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDateByPage, {
        dateDay: this.searchForm1.plannedDate,
        planType: this.activeName
      }).then(res => {
        if (res && res.list && res.list.length) {
          this.info = res.list[0]
        } else {
          this.info = {
            planNum: '0', // 计划产能
            yyPlanNum: '0', // 已约出货量
            yyMealNum: '0',
            yyMealNum2: '0', // 已约早餐量
            yyMealNum3: '0', // 已约午餐量
            yyMealNum4: '0' // 已约晚餐量
          }
        }
      })
    },
    onSearch(type) {
      if (type === '1') {
        this.page = 1
        this.loadData1()
      } else {
        this.page = 1
        this.loadData2()
      }
    },
    // 重置对应区域的筛选条件和页码，并立即刷新列表。
    onReset(formName) {
      this.$refs[formName].resetFields()
      this.onSearch(formName === 'searchForm1' ? '1' : '2')
    },

    // 运费相关
    openFreightDialog(planId, sl) {
      this.freightSl = Number(sl || 0)
      this.freightForm.planId = planId
      this.freightForm.transportCompany = ''
      this.freightForm.freightType = ''
      this.freightForm.unitPrice = ''
      this.freightForm.totalPrice = ''
      this.$nextTick(() => {
        this.$refs.freightFormRef.clearValidate()
      })
      this.freightVisible = true
    },
    calcTotalPrice() {
      const { freightType, unitPrice } = this.freightForm
      if (!freightType || !unitPrice) {
        this.freightForm.totalPrice = ''
        return
      }
      if (freightType === '1') {
        this.freightForm.totalPrice = Number(unitPrice).toFixed(2)
      } else if (freightType === '2') {
        const total = Number(unitPrice) * this.freightSl
        this.freightForm.totalPrice = Number(total.toFixed(2))
      }
    },
    submitFreight() {
      this.$refs.freightFormRef.validate().then(() => {
        this.$axios.post(this.$apis.wlFreight.insertWlFreightByPlan, this.freightForm).then(() => {
          this.$message.success('运费设置成功')
          this.freightVisible = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-view {
  color: #0e6ad7;
  text-decoration: underline;
  cursor: pointer;
}

.tabs-content {
  background-color: #FFFFFF;
  margin-bottom: 20px;
  padding-left: 20px;
  border-radius: 4px;
  ::v-deep {
    .el-tabs__header {
      margin: 0;
    }
  }
}
</style>
